import axiosPost from "../axiosPost";

export const migraVueloGet = async (
    {
        migraVueloId = null,
        migraPasoId = null,
        migraVueloTipo = null,
        migraVueloFecha = null,
        page = null,
        pageSize = null,
    } = {},
    credentials
) => {
    const body = {
        service: "MigraVueloGet",
        params: {
            migraVueloId,
            migraPasoId,
            migraVueloTipo,
            migraVueloFecha,
            page,
            pageSize,
        },
    };

    const response = await axiosPost(body, credentials);

    if (page !== null && pageSize !== null) {
        return {
            result: response.result,
            total: response.status?.id,
            status: response.status,
        };
    }

    return response;
};
